import React from 'react';
import { formatDate } from '../../../utils/dateFormatter';
import { ADMIN_COPY } from '../adminCopy';
import Icon from '../../common/Icons';

const D = ADMIN_COPY.DASHBOARD;

const TYPE_META = {
  member: { label: D.TYPE_MEMBER, icon: 'user' },
  company: { label: D.TYPE_COMPANY, icon: 'building' },
  user: { label: D.TYPE_USER, icon: 'users' }
};

function typeMeta(entityType) {
  return TYPE_META[String(entityType || '').toLowerCase()] || {
    label: D.TYPE_OTHER,
    icon: 'chartBar'
  };
}

const RecentActivitiesTable = ({ activities = [], loading = false }) => {
  if (loading) {
    return <div className="adm-activity-empty">{D.ACTIVITIES_LOADING}</div>;
  }

  if (!activities.length) {
    return <div className="adm-activity-empty">{D.ACTIVITIES_EMPTY}</div>;
  }

  return (
    <div className="adm-activity-table-wrap">
      <table className="adm-activity-table">
        <thead>
          <tr>
            <th>Activité</th>
            <th>Type</th>
            <th>Date</th>
          </tr>
        </thead>
        <tbody>
          {activities.map((activity) => {
            const meta = typeMeta(activity.entity_type);
            return (
              <tr key={activity.id}>
                <td>
                  <div className="adm-activity-title">{activity.title || 'Activité'}</div>
                  <div className="adm-activity-subtitle">{activity.subtitle || '—'}</div>
                </td>
                <td>
                  <span className="adm-activity-type">
                    <Icon name={meta.icon} size={13} aria-hidden />
                    {meta.label}
                  </span>
                </td>
                <td>{formatDate(activity.occurred_at || activity.created_at)}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default RecentActivitiesTable;
